// extracted by mini-css-extract-plugin
export var projectLinks = "ProjectLinks-module--projectLinks--3duD8";
export var title = "ProjectLinks-module--title--2oIXm {ProjectsYaml-slug}-module--metatitle--SC1_R";